import { Tooltip } from '@octopus-do/octopus-storybook'
import type React from 'react'

import { clsJoin } from '@/utils'
import type {
  SectionChangeHandler,
  SectionStat,
  SectionType,
} from '../../../../../../types'
import { getSectionState } from '../../../../../../utils'
import css from './styles.module.css'
import { useBreakdownItem } from './useBreakdownItem'

interface Props {
  section: SectionType
  title: string
  stat: SectionStat
  activeSection: SectionType
  changes: boolean
  comparison: string
  onSectionChange: SectionChangeHandler
}

export const BreakdownItem: React.FC<Props> = ({
  section,
  title,
  stat,
  activeSection,
  changes,
  comparison,
  onSectionChange,
}) => {
  const { active, deltaActive } = getSectionState(
    section,
    activeSection,
    changes
  )

  const { disabled, handleDeltaClick, handleClick } = useBreakdownItem(
    section,
    stat.count,
    onSectionChange
  )

  const cn = clsJoin(
    css.breakdown_item,
    active && css.active,
    disabled && css.disabled
  )

  return (
    <div className={cn} onClick={handleClick}>
      <div className={clsJoin(css.dot, css[section])} />
      <div>{title}</div>
      <div className={css.count}>{stat.count}</div>
      <div className={css.delta_container}>
        {stat.delta && (
          <div className={css.delta_wrap}>
            <Tooltip label={comparison}>
              <button
                className={clsJoin(css.delta, deltaActive && css.delta_active)}
                onClick={handleDeltaClick}
              >
                {stat.delta}
              </button>
            </Tooltip>
          </div>
        )}

        {!stat.delta && <div className={css.non_delta}>-</div>}
      </div>
    </div>
  )
}
